import { Trash2, X } from 'lucide-react';
import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import cartImg from '../../assets/media/empty-cart.png';
import CartContext from '../../contexts/CartContext';
import { IMAGE_BASE_URL } from '../../utils/api-client';
import PageHeader from './../Common/PageHeader';
import QuantityInput from './../Shop/QuantityInput';
import './CartPage.css';

const CartPage = () => {
  const [subTotal, setSubTotal] = useState(0);
  const { cart, removeFromCart, updateCart } = useContext(CartContext);

  useEffect(() => {
    let total = 0;
    cart.forEach((item) => {
      total += item.product.varients[0].final_price * item.quantity;
    });
    setSubTotal(total);
  }, [cart]);
  console.log(cart);
  return (
    <>
      <Helmet>
        <title>
          Hurry up! Fill your Shopping Cart with Unique Home Products
        </title>
        <meta
          name="keywords"
          content="new unique items,creative items for home,creative home decor items,creative decorative items,creative products to sell online,creative memories items for sale,creative gift supplies,creative item for home and office,unique products for home,unique home products,unique office wall decor,interesting home products,unique decorative pieces,unique home essentials,funky home decor items,unique home decorative items,unique home office decor,unique household gadgets"
        />
        <meta
          name="description"
          content="Add your favorite unique home products in a shopping cart and don’t miss the chance of purchasing unique home products to decorate your home at low budget"
        />
      </Helmet>

      <PageHeader title="Shopping Cart" />

      {/* Cart Section */}
      <section className="container-fluid my-4">
        <div className="row g-4">
          {/* Cart Items */}
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm rounded-3 overflow-hidden">
              <div className="p-3 p-md-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="card-title mb-0">Shopping Cart</h4>
                  <h6 className="text-muted mb-0">Items: {cart.length || 0}</h6>
                </div>
                <hr className="mt-2 mb-4" />

                {cart.length === 0 ? (
                  <div className="text-center py-4 py-md-5">
                    <img
                      className="rounded mb-3"
                      style={{ width: '180px', opacity: 0.7 }}
                      src={cartImg}
                      alt="empty cart"
                    />
                    <p className="lead text-muted mb-3">Your cart is empty</p>
                    <Link
                      to="/shop/"
                      className="btn btn-purple fw-semibold py-2 px-4"
                    >
                      Explore More Products
                    </Link>
                  </div>
                ) : (
                  cart.map(({ product, quantity, variant }) => (
                    <div
                      key={`${product.product_id}-${variant.p_v_id}`}
                      className="row g-3 py-3 border-bottom align-items-center"
                    >
                      {/* Desktop View */}
                      <div className="d-none d-md-flex align-items-center w-100">
                        {/* Product Image */}
                        <div className="col-1 col-lg-1 me-2">
                          {variant?.varient_images?.length > 0 && (
                            <img
                              src={`${IMAGE_BASE_URL}/${variant.varient_images[0]?.image_path}`}
                              className="rounded shadow-sm img-fluid"
                              style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                              }}
                              alt={product.product_name}
                            />
                          )}
                        </div>

                        {/* Product Info */}
                        <div className="col-5 col-lg-5">
                          <Link
                            to={`/shop/${product?.subcategory?.s_cat_slug}/${product?.product_slug}`}
                            className="h6 text-decoration-none text-purple fw-semibold mb-1 d-block text-truncate"
                          >
                            {product.product_name}
                          </Link>
                          <small className="text-muted">
                            Variant:{' '}
                            <span className="fw-semibold text-purple">
                              {variant.p_v_name}
                            </span>
                          </small>
                        </div>

                        {/* Quantity */}
                        <div className="col-3 col-lg-3">
                          <QuantityInput
                            quantity={quantity}
                            setQuantity={updateCart}
                            cartPage={true}
                            productId={product.product_id}
                            variantId={variant.p_v_id}
                            variantQty={variant.available_quantity}
                          />
                        </div>

                        {/* Price */}
                        <div className="col-2 text-center">
                          <span className="fw-bold d-block">
                            Rs {product.varients[0].final_price * quantity}
                          </span>
                          <small className="text-muted">
                            Rs {product.varients[0].final_price} / item
                          </small>
                        </div>

                        {/* Remove Button */}
                        <div className="col-1 text-center">
                          <button
                            className="btn btn-sm border-0 text-muted hover-danger p-0"
                            onClick={() =>
                              removeFromCart(product.product_id, variant.p_v_id)
                            }
                            title="Remove item"
                          >
                            <Trash2 size={20} />
                          </button>
                        </div>
                      </div>

                      {/* Mobile View */}
                      <div className="d-md-none w-100">
                        <div className="border-0">
                          <div className="row g-0 align-items-center">
                            {/* Image + Title + Remove */}
                            <div className="row w-100  g-0 mb-4 align-items-center">
                              {/* Image */}
                              <div className="col-auto me-2 d-flex">
                                <div
                                  className="bg-light border d-flex align-items-center justify-content-center rounded"
                                  style={{
                                    width: 'clamp(50px, 6vw, 60px)',
                                    height: 'clamp(50px, 6vw, 60px)',
                                    background:
                                      'linear-gradient(135deg, #d6c8ff, #b592ff)',
                                    overflow: 'hidden',
                                    flexShrink: 0, // text-truncate disturb na kare
                                  }}
                                >
                                  {variant?.varient_images?.length > 0 ? (
                                    <img
                                      src={`${IMAGE_BASE_URL}/${variant.varient_images[0]?.image_path}`}
                                      alt={product.product_name}
                                      className="w-100 h-100 rounded"
                                      style={{
                                        objectFit: 'cover',
                                        display: 'block',
                                      }}
                                      onError={(e) =>
                                        (e.currentTarget.src =
                                          '/images/no-image.png')
                                      }
                                    />
                                  ) : (
                                    <span className="fs-3 text-white d-flex align-items-center justify-content-center">
                                      🎧
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* Title + Remove */}
                              <div className="col d-flex justify-content-between align-items-start">
                                <div className="pe-2">
                                  <Link
                                    to={`/shop/${product?.subcategory?.s_cat_slug}/${product?.product_slug}`}
                                    className="fw-semibold text-purple text-decoration-none d-block"
                                    style={{
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      lineHeight: '1.3em',
                                    }}
                                  >
                                    <span
                                      className="text-truncate d-inline-block"
                                      style={{
                                        maxWidth: 'clamp(50vw, 60vw, 100vw)',
                                      }}
                                    >
                                      {product.product_name}
                                    </span>
                                  </Link>
                                  <small className="text-muted d-block">
                                    Variant:{' '}
                                    <span className="fw-semibold text-purple">
                                      {variant.p_v_name}
                                    </span>
                                  </small>
                                </div>

                                <button
                                  className="btn btn-sm p-0 border-0 text-muted hover-danger"
                                  onClick={() =>
                                    removeFromCart(
                                      product.product_id,
                                      variant.p_v_id
                                    )
                                  }
                                  title="Remove item"
                                  aria-label="Remove item"
                                >
                                  <X size={18} />
                                </button>
                              </div>
                            </div>

                            {/* Quantity + Price */}
                            <div className="row w-100 g-0  align-items-center">
                              <div className="col-auto">
                                <QuantityInput
                                  quantity={quantity}
                                  setQuantity={updateCart}
                                  cartPage={true}
                                  productId={product.product_id}
                                  variantId={variant.p_v_id}
                                  variantQty={variant.available_quantity}
                                  compact={true}
                                />
                              </div>
                              <div className="col text-end">
                                <div className="fw-bold text-dark">
                                  Rs{' '}
                                  {product.varients[0].final_price * quantity}
                                </div>
                                <small className="text-muted">
                                  Rs {product.varients[0].final_price} ×{' '}
                                  {quantity}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Free Shipping Note */}
              <div className="px-4 py-3 border-top bg-light-purple">
                <p className="mb-0 small">
                  <i className="fas fa-truck me-2 text-purple"></i>
                  Free Shipping on Orders Above Rs. 3000
                </p>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="col-lg-4 col-xl-3">
            <div className="card rounded-3 shadow-sm">
              <div className="card-body p-4 sticky-top" style={{ top: '20px' }}>
                <h5 className="fw-bold mb-4">Order Summary</h5>

                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Subtotal:</span>
                  <span className="fw-medium">Rs {subTotal}</span>
                </div>

                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Shipping:</span>
                  <span className="fw-medium">—</span>
                </div>

                <hr className="my-3" />

                <div className="d-flex justify-content-between mb-3">
                  <span className="fw-semibold">Total:</span>
                  <span className="fw-bold fs-5 text-purple">
                    Rs {subTotal}
                  </span>
                </div>

                <div className="mt-4">
                  {cart.length > 0 ? (
                    <Link
                      to="/checkout"
                      className="btn btn-sm btn-purple w-100 fw-semibold"
                    >
                      Proceed to Checkout
                    </Link>
                  ) : (
                    <Link
                      to="/shop"
                      className="btn btn-outline-secondary w-100 fw-medium py-2"
                    >
                      Continue Shopping
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CartPage;
